if (!customElements.get("accordion-animation-details")) {
  customElements.define(
    "accordion-animation-details",

    /**
     * 折叠手风琴，适配动画效果，包裹于 <animation-details>
     */
    class AnimationAnimationDetails extends HTMLElement {
      constructor() {
        super();
        const detailsList = this.querySelectorAll("animation-details");
        this.addEventListener("details:open", (e) => {
          const target = e.target;
          for (const details of detailsList) {
            if (target != details) {
              details.closeDetails();
            }
          }
        });
      }
    }
  );
}

if (!customElements.get("animation-details")) {
  customElements.define(
    "animation-details",
    /**
     * 适配动画效果，包裹于原生 <details>
     * 类名 details-opening 标记 details 正在开启的过渡动画中
     * 类名 details-opening 标记 details 正在关闭的过渡动画中
     * 
     * Attribute: 
     * - data-animation-time: 动画时长
     */
    class AnimationDetails extends HTMLElement {
      constructor() {
        super();
        this.maxElapsedTime = Number(this.getAttribute('data-animation-time') ?? 200);
      }

      init() {
        this.mainDetailsToggle = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.content = this.summary.nextElementSibling;

        // Recheck the open state when the component is connected
        if (this.mainDetailsToggle.hasAttribute('open')) {
          this.openDetails();
        } else {
          this.closeDetails();
        }

        this._onSummaryClick = this.onSummaryClick.bind(this);
        this.summary.addEventListener('click', this._onSummaryClick);
      }

      connectedCallback() {
        this.init();

        // Observe changes to the element's children
        this.observer = new MutationObserver(() => {
          this.summary.removeEventListener('click', this._onSummaryClick);
          this.init();
        });
        this.observer.observe(this, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        this.summary.removeEventListener('click', this._onSummaryClick);
      }

      onSummaryClick(event) {
        const isOpen = this.mainDetailsToggle.hasAttribute('open');
        const isOpening = this.mainDetailsToggle.classList.contains('details-opening');
        const isClosing = this.mainDetailsToggle.classList.contains('details-closing');
        if (isOpening || isClosing) {
          event.preventDefault();
          return false;
        } else if (isOpen) {
          this.closeDetails();
          event.preventDefault();
        } else {
          this.openDetails();
        }
      }

      get isOpened() {
        return this.mainDetailsToggle.hasAttribute('open');
      }

      openDetails() {
        this.mainDetailsToggle.classList.add('details-opening');
        this.mainDetailsToggle.style.height = this.summary.clientHeight + 'px';
        window.requestAnimationFrame(() => {
          this.mainDetailsToggle.setAttribute('open', '');
          this.mainDetailsToggle.style.height = this.content.clientHeight + this.summary.clientHeight + 'px';
          this.summary.setAttribute('aria-expanded', true);
          this.dispatchEvent(new CustomEvent("details:open", { bubbles: true }));
        });
        setTimeout(() => {
          this.mainDetailsToggle.classList.remove('details-opening');
          this.mainDetailsToggle.style.height = '';
        }, this.maxElapsedTime);
      }

      closeDetails() {
        if (!this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.classList.contains('details-opening')) return;
        this.mainDetailsToggle.classList.remove('details-opening');
        this.mainDetailsToggle.classList.add('details-closing');
        this.mainDetailsToggle.style.height = this.content.clientHeight + this.summary.clientHeight + 'px';
        window.requestAnimationFrame(() => this.mainDetailsToggle.style.height = (this.summary?.clientHeight ?? 0) + 'px');
        this.closeAnimation(this.mainDetailsToggle);
        this.dispatchEvent(new CustomEvent("details:close", { bubbles: true }));
      }

      toggleDetails() {
        if (this.isOpened) {
          this.closeDetails();
        } else {
          this.openDetails();
        }
      }

      resize(entries, observer) {
        if (this.mainDetailsToggle.classList.contains('details-closing') || this.mainDetailsToggle.classList.contains('details-opening')) return;
        if (this.mainDetailsToggle.hasAttribute('open')) {
          this.mainDetailsToggle.style.height = this.content.clientHeight + this.summary.clientHeight + 'px';
        } else {
          this.mainDetailsToggle.style.height = this.summary.clientHeight + 'px';
        }
      }

      closeAnimation() {
        let animationStart;

        const handleAnimation = (time) => {
          if (animationStart === undefined) {
            animationStart = time;
          }

          const elapsedTime = time - animationStart;

          if (elapsedTime < this.maxElapsedTime) {
            window.requestAnimationFrame(handleAnimation);
          } else {
            this.mainDetailsToggle.removeAttribute('open');
            this.mainDetailsToggle.classList.remove('details-opening');
            this.mainDetailsToggle.classList.remove('details-closing');
            this.mainDetailsToggle.style.height = '';
            if (this.mainDetailsToggle.closest('details[open]')) {
              trapFocus(this.mainDetailsToggle.closest('details[open]'), this.mainDetailsToggle.querySelector('summary'));
            }
          }
        };
        window.requestAnimationFrame(handleAnimation);
      }
    }
  );
}
